import { useEffect, useRef } from 'react'

export function useIsFirstRender(): { isFirstRender: boolean } {
  const isFirstRender = useRef(true)

  useEffect(() => {
    isFirstRender.current = false
  }, [])

  return { isFirstRender: isFirstRender.current }
}
